/*
 * Helper composable that uses the routeHistoryCount middleware to keep track
 * of (the number of) route navigations
 */
const routeHistoryCount = ref(0);

export const useRouteHistoryCount = () => {
  return routeHistoryCount;
};
